import { AfterViewChecked, ChangeDetectorRef, Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { DateSelectCellComponent } from '@shared/components/ag-grid-components/cell-renderers/date-select-cell/date-select-cell.component';
import moment from 'moment';

@Component({
    selector: 'app-date-select-cell-editor',
    templateUrl: './date-select-cell-editor.component.html',
    styleUrls: ['./date-select-cell-editor.component.scss'],
    standalone: false,
})
export class DateSelectCellEditorComponent extends DateSelectCellComponent implements ICellEditorAngularComp, AfterViewChecked {
    editorOpened = false;

    constructor(private cdRef: ChangeDetectorRef) {
        super();
    }

    // @ts-expect-error TS7053: implicit any
    agInit(params): void {
        super.agInit(params);
        this.dateFilter.OnChange((date) => {
            this.onChange(date);
        });
    }

    getValue(): moment.Moment | null | undefined {
        return this.dateFilter.Value;
    }

    ngAfterViewChecked(): void {
        if (!this.editorOpened) {
            const popup = document.getElementsByClassName('ag-popup-editor').item(0);
            if (popup) {
                (popup as HTMLElement).focus();
                this.editorOpened = true;
            }
        }
        this.cdRef.detectChanges();
    }

    isPopup(): boolean {
        return true;
    }

    override refresh(): boolean {
        return true;
    }
}
